// extracted by mini-css-extract-plugin
export default {"WishChartBuildings":"WishChartBuildings_WishChartBuildings__HNLWT"};